import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "capitalize" }
const _hoisted_2 = { class: "grid grid-cols-12 gap-5" }
const _hoisted_3 = {
  key: 0,
  class: "col-span-5"
}
const _hoisted_4 = { class: "col-span-12 flex flex-col gap-5" }
const _hoisted_5 = { class: "flex items-center justify-between mb-4" }
const _hoisted_6 = {
  key: 1,
  class: "col-span-12 bg-white rounded-lg py-6 shadow"
}
const _hoisted_7 = {
  key: 2,
  class: "col-span-12"
}
const _hoisted_8 = { class: "flex flex-col lg:!flex-row items-center gap-5" }
const _hoisted_9 = { class: "flex flex-wrap justify-start md:justify-between gap-3 relative" }
const _hoisted_10 = { class: "flex justify-center flex-wrap gap-[1.2rem]" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "flex flex-col gap-3" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "text-[14px]" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "E-mail:", -1)
const _hoisted_16 = { class: "text-[14px]" }
const _hoisted_17 = { class: "text-[11px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.user?.userName), 1),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.classroomName)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t("labels.generic", { pt: "Turma: ", en: "Classroom: " }) +
          _ctx.classroomName), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("stats.course.sidebar.general")), 1),
          _createVNode(_component_Button, {
            label: _ctx.$t('labels.generic', { pt: 'Baixar', en: 'Download' }),
            icon: "pi pi-download",
            class: "p-button-sm btn-primary h-9",
            loading: _ctx.btnLoading,
            onClick: _ctx.downloadCsv
          }, null, 8, ["label", "loading", "onClick"])
        ])
      ]),
      (!_ctx.user?.userName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_EmptyData, {
              data: !_ctx.user?.userName,
              title: _ctx.emptyState.title,
              label: _ctx.emptyState.description,
              image: _ctx.emptyState.image,
              imgSize: "h-40 my-10"
            }, null, 8, ["data", "title", "label", "image"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, i) => {
                return (_openBlock(), _createBlock(_component_Card, {
                  key: i,
                  data: item,
                  isEmpty: item?.empty
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("img", {
                          class: "w-16 h-16 rounded-md",
                          src: item?.icon,
                          alt: "img-icon"
                        }, null, 8, _hoisted_11),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("p", {
                            class: "truncate max-w-[200px] text-[14px]",
                            title: item?.userName
                          }, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Nome:", en: "Name:" })), 1),
                            _createTextVNode(" " + _toDisplayString(item?.userName), 1)
                          ], 8, _hoisted_13),
                          _createElementVNode("p", _hoisted_14, [
                            _hoisted_15,
                            _createTextVNode(" " + _toDisplayString(item?.userEmail), 1)
                          ]),
                          _createElementVNode("p", _hoisted_16, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("labels.generic", {
                          pt: "Última data de acesso:",
                          en: "Last access:",
                        })), 1),
                            _createTextVNode(" " + _toDisplayString(item?.lastAccess), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(`${item?.studentStatus?.class} h-fit absolute top-0 right-0 py-1 px-2 rounded-md text-xs w-100`)
                      }, [
                        _createElementVNode("p", _hoisted_17, _toDisplayString(item?.studentStatus?.name), 1)
                      ], 2)
                    ])
                  ]),
                  _: 2
                }, 1032, ["data", "isEmpty"]))
              }), 128))
            ])
          ]))
    ])
  ]))
}